module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"hi":"Merhaba","userProfile":"Kullanıcı Profili","logout":"Güvenli Çıkış","messageCount":"12 Mesaj","myProfile":"Profilim","myProfileDesc":"Profil bilgilerinizi buradan güncelleyebilirsiniz."},"en":{"hi":"Hi","userProfile":"User Profile","logout":"Logout","messageCount":"12 Message","myProfile":"My Profile","myProfileDesc":"Account Informations"}}')
  delete Component.options._Ctor
}
